module.exports = __webpack_public_path__ + "static/img/7.84a6c70.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/7.png
// module id = CVj6
// module chunks = 4